/**
 * Whether an embedded table's collapse toggle is worth showing.
 *
 * A group with one item gains nothing from collapsing — the summary replaces the item on the same
 * single row, hiding data without reclaiming space — and an empty group has nothing to hide. An
 * already collapsed group always keeps its toggle, so a refresh that shrinks it cannot leave it
 * collapsed with no way back.
 */
export const shouldShowCollapseToggle = ({
  itemsCount,
  isCollapsed,
}: {
  itemsCount: number;
  isCollapsed: boolean;
}): boolean => isCollapsed || itemsCount > 1;
